import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-10 flex items-center justify-center"
}
const _hoisted_2 = {
  key: 1,
  class: "p-10 w-full h-full inline-flex flex-col items-center justify-center"
}
const _hoisted_3 = { class: "font-medium text-base text-gray-900 mb-4" }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 0,
  class: "mb-4 legal-policy-text"
}
const _hoisted_6 = { href: "#BPM" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = { ref: "htmlContainer" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = ["id", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageLoading = _resolveComponent("PageLoading")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_PageLoading)
      ]))
    : (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('platform.legal.error-loading-policy')), 1),
          _createVNode(_component_BaseButton, {
            color: "primary",
            "left-icon": "reload",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fetchPolicyHtml()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('platform.error.try-again')), 1)
            ]),
            _: 1
          })
        ]))
      : (_ctx.legalPolicyHtmls.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.branding && _ctx.legalPolicyHtmls.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.$t(`platform.legal.${_ctx.type}.combined`)), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('platform.legal.navigation-header')), 1),
                  _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$t(`platform.legal.${_ctx.type}.title`)) + " (Big Picture)", 1),
                  _hoisted_7,
                  _createElementVNode("a", {
                    href: `#${_ctx.branding}`
                  }, _toDisplayString(_ctx.$t(`platform.legal.${_ctx.type}.title`)) + " (" + _toDisplayString(_ctx.$t(`platform.legal.${_ctx.branding}`)) + ")", 9, _hoisted_8),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('platform.legal.disclaimer')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legalPolicyHtmls, (legalPolicyHtml, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (_ctx.branding && _ctx.legalPolicyHtmls.length > 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_10,
                        _hoisted_11,
                        _hoisted_12
                      ], 64))
                    : _createCommentVNode("", true),
                  (!_ctx.isEnglishRegion && index === 0)
                    ? (_openBlock(), _createBlock(_component_BaseAlert, {
                        key: 1,
                        value: _ctx.$t('platform.legal.fallback-alert'),
                        icon: "info",
                        class: "mb-4"
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    id: _ctx.branding && index === 0 ? 'BPM' : _ctx.branding,
                    class: "legal-policy-text",
                    innerHTML: legalPolicyHtml
                  }, null, 8, _hoisted_13)
                ]))
              }), 128))
            ], 512)
          ]))
        : _createCommentVNode("", true)
}